<template>
  <div class="page-content" style="background-color: #fff;padding: 20px">
    <el-row>
      <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item>活动信息</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/Brand/floatingPlaten/main' }">活动模板</el-breadcrumb-item>
        <el-breadcrumb-item v-if="isInAddPage">创建模板</el-breadcrumb-item>
        <el-breadcrumb-item v-if="!isInAddPage">模板详情</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
		<ActivityForm
			ref="activityForm"
			:productsArr="products"
			:isInTemplate="isInTemplate"
			:isInAddTemplate="isInAddPage"
			:needDiabled="needDiabled"
			:canEdit="canEdit"
			@on-way-change="onWayChange"
			@on-add-product="onAddProduct"
			:ruleForm="ruleForm"
      @on-excel-data="onExcelData"
		/>

		<ProductDialog
			:data="productData"
			:visible="productVisible"
			:products="products"
			:isNotInAddPage="!isInAddPage"
			@on-close="onCloseProductDialog"
			@on-finish-product="onCloseProductDialog"
			ref="productDialog"
      @fatherBlur="inputBlur"
		/>
		<ActivityTable
			style="margin-top: 20px"
			ref="activityTable"
			:data="products"
			:isInTemplate="isInTemplate"
      :headerData="headerData"
      :excelData="newExcelData"
			:canEdit="canEdit"
			:mode="mode"
			class="activityTable">
			<template v-slot:operate="scope">
				<el-button v-if="canEdit" size="small" @click="onDeleteProduct(scope.data)" type="plain" icon="el-icon-remove-outline"></el-button>
			</template>
		</ActivityTable>
		<div class="g-center add-apply-btn-box" @click="onAddOrDeleteRow({flag: 1})" v-if="mode === 1">
			<span><i class="el-icon-plus"></i> 添加一行</span>
		</div>
		<div style="margin-top: 20px">
			<el-button v-if="isInAddPage" class="save-btn" size="small" type="primary" @click="onSaveTemplate('add')">保存</el-button>
			<el-button v-if="!isInAddPage" class="save-btn" size="small" type="primary" @click="onModifyOrSaveTemplate">{{ canEdit ? '保存' : '修改活动模板' }}</el-button>
			<el-button v-if="!isInAddPage && canEdit" size="small" type="plain" @click="onCancelTemplate">取消</el-button>
		</div>
  </div>
</template>
<script>
import ActivityForm from 'components/activityForm/activityForm';
import ProductDialog from 'components/productDialog/productDialog';
import ActivityTable from 'components/activityTable/activityTable';
import _ from 'lodash';
import ActivityMixin from '@/mixins/activityMixin.js';
import { mapState, mapGetters, mapActions } from 'vuex';
import axios from "axios";
export default {
	components: {
		ActivityTable,
		ProductDialog,
		ActivityForm
	},

	mixins: [
		ActivityMixin
	],

  data() {
    return {
			cacheProducts: [],
			isInAddPage: false,
			isInTemplate: true,
			canEdit: true,
			ruleForm: {
				campaignway: 0,
				templatename: '',
			},
			needDiabled: false,
      cascaderProps: {
        value: 'id',
        label: 'productClassifyName'
      },
      cascaderProps2: {
        value: 'id',
        label: 'productClassifyName'
      },
      shopname: '',
      platform: '',
      shopid: '',
      newExcelData: {},
    };
  },
  methods: {
    inputBlur() {
      console.log('调用')
      this.newAdd()
    },
    // 新增监控产品
    newAdd() {
      let params = {
        pageNum: 1,
        pageSize: 10000,
      }
      fetch({
        url: "hcm/ProductClassify/seletProductClassify",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.productData = res.data.data.list
          console.log(this.productData)
          this.$refs.productDialog.open(res.data.data.list)
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    onExcelData(data) {
      console.log(data)
      if(data.flag === '1') {
				this.products = data.excelData;
			}else {
				this.products.push(...data.excelData)
			}
    },
		onCancelTemplate() {
			this.products = this.cacheProducts;
			this.canEdit = false;
			this.needDiabled = true;
		},
		onModifyOrSaveTemplate() {
			// 缓存一份products
			this.cacheProducts = _.cloneDeep(this.products);;
			if(this.canEdit) {
				const id = this.$route.query.id;
				this.onSaveTemplate(id);
			}else {
				this.canEdit = true;
				this.needDiabled = false;
			}
		},
    ...mapActions([
			'reqActivityShopProduct',
      'reqActivityDealerShops',
      'reqActivityShopProduct',
      'reqShopProductLink',
      'reqIsLowPrice',
      'reqActivitySetting',
      'reqApplyActivity',
    ]),
		echoForm(data) {
			this.ruleForm.templatename = data[0].templatename;
			this.ruleForm.campaignway = parseInt(this.$route.query.mode);
			this.mode = parseInt(this.$route.query.mode);
		},
	},
  async created(){
		if(this.getUserLoginType === 'DEALER') {
			this.isDealer = true;
			// this.reqActivityDealerShops();
      this.newAdd()
			// this.productData = await this.reqActivityShopProduct({});
		}
		this.initProductData(this.mode);
		if(this.$route.query.sureShow) {
			this.isInAddPage = true;
		}else {
			this.canEdit = false;
			this.needDiabled = true;
			const id = this.$route.query.id;
			const res = await this.reqActivityDecalareTemplateDetail({
				id
			})
			this.echoForm(res);
			const data = this.handleTemplateData(res);
			this.echoTableData(data, this.mode);
		}
		!this.isDealer && this.getProductInfo();
  },
  computed: {
    ...mapGetters([
      'getDealerShops',
      'getShopProducts',
			'getProductLink',
			'getUserLoginType'
    ])
  },
};
</script>
<style lang="scss">
.save-btn {
	background-color: #D3A977;
	border-color: #D3A977;

	&:hover {
		background-color: #D3A977;
		border-color: #D3A977;
	}
}
</style>
